import { cn } from "tailwind-variants";

export default function PinningHeader({ isDesktop = false, ...restProps }) {
  return (
    <div
      {...restProps}
      className={cn("flex w-full shrink-0 flex-col bg-white p-4 shadow-sm", restProps.className)}
      data-testid="pinning-header"
    >
      <h2 className="m-0 text-lg font-semibold text-gray-800">Get Free Artist Edits</h2>
    </div>
  );
}
